import { gql } from '@apollo/client';
export const deleteTeam = gql `
  mutation deleteTeam($id: UUID!) {
    deleteTeam(id: $id) {
      id
    }
  }
`;
